<script lang="ts">
export default {
  name: 'Toggle',
};
</script>

<script setup lang="ts">
const model = defineModel<boolean>();

const props = defineProps<{
  id?: string;
  label: string;
  variant?: 'default' | 'primary' | 'secondary' | 'accent' | 'neutral' | 'success' | 'warning' | 'info' | 'error';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  disabled?: boolean;
}>();

const getVariantClass = (variant?: string) => {
  switch (variant) {
    case 'primary':
      return 'toggle-primary';
    case 'secondary':
      return 'toggle-secondary';
    case 'accent':
      return 'toggle-accent';
    case 'neutral':
      return 'toggle-neutral';
    case 'success':
      return 'toggle-success';
    case 'warning':
      return 'toggle-warning';
    case 'info':
      return 'toggle-info';
    case 'error':
      return 'toggle-error';
    case 'default':
    default:
      return 'toggle-primary';
  }
};

const getSizeClass = (size?: string) => {
  switch (size) {
    case 'xs':
      return 'toggle-xs';
    case 'sm':
      return 'toggle-sm';
    case 'lg':
      return 'toggle-lg';
    case 'xl':
      return 'toggle-xl';
    case 'md':
    default:
      return 'toggle-md';
  }
};
</script>

<template>
  <label
    :for="id"
    class="label flex items-center gap-0">
    <input
      :id="id"
      type="checkbox"
      v-model="model"
      :checked="model"
      :disabled="disabled"
      class="toggle"
      :class="[getVariantClass(props.variant), getSizeClass(props.size)]" />

    <span class="label-text cursor-pointer pl-2 select-none text-sm">
      {{ label }}
    </span>
  </label>
</template>
